import { render, staticRenderFns } from "./AccidentWarrantys.vue?vue&type=template&id=b82d3e5c&"
import script from "./AccidentWarrantys.vue?vue&type=script&lang=js&"
export * from "./AccidentWarrantys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports